module.exports = __webpack_public_path__ + "static/Sporting_Grotesque-Bold_web-7dd2e93f028228307991e7506e88eef6.svg";